if (!customElements.get('tc-home-tabs')) {
  customElements.define('tc-home-tabs', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      const activate = (tab, focus = false) => {
        this.tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
        if (focus) tab.focus();
      };
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab), options);
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); activate(this.tabs[next], true); }
        }, options);
      });
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[role="tabpanel"]');
        const tab = panel && this.tabs.find(item => item.getAttribute('aria-controls') === panel.id);
        if (tab) activate(tab);
      }, options);
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
if (!customElements.get('tc-home-header')) {
  customElements.define('tc-home-header', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const menuButton = this.querySelector('[data-menu-toggle]');
      const searchButton = this.querySelector('[data-search-toggle]');
      const menu = this.querySelector('.tc-mobile-nav');
      const search = this.querySelector('.tc-search');
      const close = () => {
        menu.hidden = true; search.hidden = true;
        menuButton.setAttribute('aria-expanded', 'false');
        searchButton.setAttribute('aria-expanded', 'false');
      };
      menuButton.addEventListener('click', () => {
        const open = menu.hidden; close(); menu.hidden = !open;
        menuButton.setAttribute('aria-expanded', String(open));
      }, options);
      searchButton.addEventListener('click', () => {
        const open = search.hidden; close(); search.hidden = !open;
        searchButton.setAttribute('aria-expanded', String(open));
        if (open) search.querySelector('input').focus();
      }, options);
      menu.addEventListener('click', event => { if (event.target.closest('a')) close(); }, options);
      document.addEventListener('click', event => { if (!this.contains(event.target)) close(); }, options);
      this.addEventListener('keydown', event => {
        if (event.target.closest('localization-form')) return;
        if (event.key !== 'Escape') return;
        const trigger = !search.hidden ? searchButton : menuButton;
        close(); trigger.focus();
      }, options);
      const messages = Array.from(this.querySelectorAll('.tc-ann-messages p'));
      let current = 0;
      const change = step => {
        if (!messages.length) return;
        current = (current + step + messages.length) % messages.length;
        messages.forEach((item, i) => { item.hidden = i !== current; });
      };
      this.querySelector('[data-ann-prev]')?.addEventListener('click', () => change(-1), options);
      this.querySelector('[data-ann-next]')?.addEventListener('click', () => change(1), options);
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}

if (!customElements.get('tc-home-announcement')) {
  customElements.define('tc-home-announcement', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const messages = Array.from(this.querySelectorAll('.tc-ann-messages p'));
      let current = 0;
      const show = index => {
        if (!messages.length) return;
        current = (index + messages.length) % messages.length;
        messages.forEach((item, i) => { item.hidden = i !== current; });
      };
      this.querySelector('[data-ann-prev]')?.addEventListener('click', () => show(current - 1), options);
      this.querySelector('[data-ann-next]')?.addEventListener('click', () => show(current + 1), options);
      this.addEventListener('shopify:block:select', event => {
        const index = messages.findIndex(item => item === event.target || item.contains(event.target));
        if (index !== -1) show(index);
      }, options);
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
